import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
export function ContactFooter() {
  return <footer className="bg-black text-white pt-16 pb-8 border-t border-gray-900" data-id="element-575">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-576">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-577">
          <div data-id="element-578">
            <div className="flex items-center gap-3 mb-6" data-id="element-579">
              <div className="relative w-10 h-10 overflow-hidden rounded-full border border-[#00D4FF] bg-black" data-id="element-580">
                <img src="https://cdn.magicpatterns.com/uploads/fmBXjQm2BPtC5bTSRKvwCz/walkerlogo-gigapixel-cgi-3600w.png" alt="Walker's Martial Arts Logo" className="w-full h-full object-cover" data-id="element-581" />
              </div>
              <div className="flex flex-col" data-id="element-582">
                <span className="text-white font-bold text-base leading-none tracking-wide uppercase" data-id="element-583">
                  Walker's
                </span>
                <span className="text-[#00D4FF] font-bold text-xs leading-none tracking-wider uppercase" data-id="element-584">
                  Martial Arts
                </span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 max-w-xs" data-id="element-585">
              "Where Families Kick Together"
              <br data-id="element-586" />
              Proudly serving the Bloomington community and surrounding area
              since 1999.
            </p>
            <div className="flex gap-4" data-id="element-587">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-588">
                <Facebook size={20} data-id="element-589" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-900 flex items-center justify-center text-gray-400 hover:bg-[#00D4FF] hover:text-black transition-all" data-id="element-590">
                <Instagram size={20} data-id="element-591" />
              </a>
            </div>
          </div>
          <div data-id="element-592">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-593">
              Contact Us
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-594">
              <li className="flex items-start gap-3" data-id="element-595">
                <MapPin className="w-5 h-5 text-[#00D4FF] shrink-0 mt-1" data-id="element-596" />
                <span className="text-sm" data-id="element-597">
                  1304 E. Empire Suite 2.
                  <br data-id="element-598" />
                  Bloomington, Illinois 61701
                  <br data-id="element-599" />
                  <span className="text-xs text-gray-500" data-id="element-600">
                    (Inside the Regions Bank Complex at the intersection of
                    Empire & Towanda)
                  </span>
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-601">
                <Phone className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-602" />
                <a href="tel:3092422440" className="hover:text-white transition-colors" data-id="element-603">
                  (309) 242-2440
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-604">
                <Mail className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-605" />
                <a href="mailto:walkerskicks@gmail.com" className="hover:text-white transition-colors" data-id="element-606">
                  walkerskicks@gmail.com
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-607">
            <h4 className="text-lg font-bold text-white mb-6 uppercase tracking-wider" data-id="element-608">
              Class Hours
            </h4>
            <ul className="space-y-2 text-gray-400" data-id="element-609">
              <li className="flex justify-between" data-id="element-610">
                <span data-id="element-611">Monday - Thursday</span>
                <span className="text-white" data-id="element-612">5:00 AM - 9:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-613">
                <span data-id="element-614">Friday</span>
                <span className="text-white" data-id="element-615">5:00 AM - 7:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-616">
                <span data-id="element-617">Saturday</span>
                <span className="text-white" data-id="element-618">9:00 AM - 2:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-619">
                <span data-id="element-620">Sunday</span>
                <span className="text-white" data-id="element-621">8:00 AM - 12:00 PM</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-622">
          <p data-id="element-623">
            &copy; {new Date().getFullYear()} Walker's Martial Arts. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-624">
            <a href="#" className="hover:text-white transition-colors" data-id="element-625">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-626">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}